import m2_examRegMenu from '@components/examRegMenu/m2_examRegMenu.vue'
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        "examRegMenu": m1_examRegMenu,
        'm2ExamRegMenu': m2_examRegMenu,
        "m2Sidebar": m2Sidebar,
    },
    data() {
        return {
            tip: "",
            compulsory_group: [],
            optional_group: [],
            subject_group: [],
            choose_subject: [],
            choose_subject_ids: [],
            choose_type: [],
            subject_show: false,
            field: {},
            btnDisable: false,
            haveType: false,
            subject_types: [],
            subject_type_levels: [],
            pay_switch_status: ""
        };
    },
    methods: {
        getData: function () {
            this.pay_switch_status = this.$store.state.examRegInfo.examRegInfo.pay_switch_status;
            if (
                this.$store.state.examRegInfo.examRegInfo.region_subject_selections.region_id
            ) {
                this.$http.get(globalProvider.serviceUrl("e_reg/q/st")).then(data => {
                    if (data.body.code === resultCode.Success) {
                        this.FirstGetSubject();
                        if (data.body.data && data.body.data.subject_types.length > 0) {
                            this.haveType = true;
                            this.subject_types = [];
                            this.subject_types[0] = data.body.data.subject_types;
                            this.subject_type_levels = data.body.data.subject_type_levels;
                        }
                    }
                });
            } else {
                this.$router.push({
                    name: "default.examReg.chooseExamRegion"
                });
            }
        },
        //获取页面提示信息
        getTip: function () {
            this.$http.get(globalProvider.serviceUrl("e_reg/g/sts/{key_code}"), {
                    params: {
                        key_code: tipKeyCode.subject_reg_success
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        if (data.body.data != null) {
                            this.tip = data.body.data.key_value;
                        }
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
        },
        FirstGetSubject() {
            this.$http.get(globalProvider.serviceUrl("e_reg/g/subs/{region_id}/{reg_id}"), {
                    params: {
                        region_id: this.$store.state.examRegInfo.examRegInfo.region_subject_selections.region_id,
                        reg_id: this.$store.state.examRegInfo.examRegInfo.exam_registration_id
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        this.rule = data.body.data.subject_rules;
                        this.compulsory_group =
                            data.body.data.subject_data.compulsory_group;
                        this.optional_group = data.body.data.subject_data.optional_group;
                        this.field = this.$store.state.examRegInfo.examRegInfo.region_subject_selections;
                        for (let i in this.compulsory_group) {
                            this.choose_subject.push(this.compulsory_group[i]);
                            this.choose_subject_ids.push(this.compulsory_group[i].subject_id);
                        }
                        if (this.field.subjects) {
                            for (let i in this.field.subjects) {
                                for (let j in this.optional_group) {
                                    if (
                                        this.optional_group[j].subject_id == this.field.subjects[i].subject_id
                                    ) {
                                        this.choose_subject.push(this.optional_group[j]);
                                        this.choose_subject_ids.push(
                                            this.optional_group[j].subject_id
                                        );
                                    }
                                }
                            }
                        }
                    }
                });
        },
        chooseType(index, type) {
            this.subject_show = false;
            if (index < this.choose_type.length) {
                this.subject_types.splice(index + 1, 10);
                this.choose_type.splice(index, 10);
            }
            this.choose_type[index] = type.id;
            //判断类别是否有下级
            if (typeof type.children != "object") {
                this.subject_show = true;
                this.getSubject();
            } else {
                this.subject_types[index + 1] = type.children;
            }
        },
        getSubject() {
            this.$http.get(globalProvider.serviceUrl("e_reg/g/subs/{region_id}/{reg_id}/{subject_type_ids}"), {
                    params: {
                        region_id: this.$store.state.examRegInfo.examRegInfo
                            .region_subject_selections.region_id,
                        reg_id: this.$store.state.examRegInfo.examRegInfo
                            .exam_registration_id,
                        subject_type_ids: this.choose_type.join(",")
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        this.subject_group = data.body.data.subject_data.compulsory_group.concat(
                            data.body.data.subject_data.optional_group
                        );
                    }
                });
        },
        chooseSubject: function (e, item) {
            if (this.choose_subject_ids.indexOf(item.subject_id) != -1) {
                this.choose_subject.splice(
                    this.choose_subject_ids.indexOf(item.subject_id),
                    1
                );
                this.choose_subject_ids.splice(
                    this.choose_subject_ids.indexOf(item.subject_id),
                    1
                );
            } else {
                if (this.rule[item.subject_id]) {
                    if (this.rule[item.subject_id].length > 0) {
                        let list = [];
                        this.choose_subject.forEach(n => {
                            for (let i in this.rule[item.subject_id]) {
                                if (n.subject_id == this.rule[item.subject_id][i]) {
                                    list.push(this.choose_subject.indexOf(n));
                                }
                            }
                        });
                        list.reverse();
                        for (let item in list) {
                            this.choose_subject.splice(list[item], 1);
                            this.choose_subject_ids.splice(list[item], 1);
                        }
                    }
                }
                this.choose_subject.push(item);
                this.choose_subject_ids.push(item.subject_id);
            }
        },
        beSelected: function (item) {
            if (this.choose_subject_ids.indexOf(item.subject_id) != -1) {
                return true;
            } else {
                return false;
            }
        },
        preStep: function () {
            this.$router.push({
                name: "default.examReg.chooseExamRegion"
            });
        },
        nextStep: function () {
            this.btnDisable = true;
            let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
            if (this.choose_subject.length > 0) {
                this.field.subjects = this.choose_subject;
                this.$http
                    .post(globalProvider.serviceUrl("e_reg/us/rgsi/rs"), {
                        eri: examRegInfo.exam_registration_id,
                        ri: this.field.region_id,
                        sis: this.choose_subject_ids
                    })
                    .then(data => {
                        this.btnDisable = false;
                        if (data.body.code === resultCode.Success) {
                            this.$store.commit("setExamRegInfoItem", {
                                region_subject_selections: this.field
                            });
                            this.$router.push({
                                name: "default.examReg.submitRegInfo"
                            });
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message));
                        }
                    });
            } else {
                this.btnDisable = false;
                this.$alert("请选择至少一个科目", {
                    confirmButtonText: "确定"
                });
            }
        }
    },
    created: function () {
        this.$store.commit("setHeaderState", "3");
        this.getData();
        this.getTip();
    }
};